<div class="d-flex align-items-center flex-row root-div">
  <div class="col-md-6 h-100 overflow-auto me-3">
    <app-zorro-table
      [tableId]="'testcase-table'"
      class="w-100"
      [columns]="configs.columns"
      [data]="configs.rows | sortByString:'key':'asc':'storyId'"
      [options]="zorroOptions"
      [meta]="meta"
      [activeRowId]="selectedRow?.id"
      (handleActions)="handleTableActions($event)"
      (onRowSelect)="handleRowSelection($event)"
      (filterActions)="handleFilterActions($event)"
      (pageChange)="onPageChange($event)"
      (testCaseFilterAction)="handleTestCaseFilterAction($event)"
    ></app-zorro-table>
  </div>
  <div
    class="col-md-6 h-100 d-flex justify-content-flex-start flex-column"
    *ngIf="selectedRow != null"
  >
  <h4 class="modal-title header-2 flex-grow-1" *ngIf="configs.header">{{configs.header}}</h4>

    <div class="container h-100">
      <div class="top-right" *ngIf="configs?.isEdit">
        <span (click)="toggleEdit()" (keydown.enter)="toggleEdit()">
          <img
            *ngIf="!editMode"
            src="assets/images/virtusa-icons/edit-light.svg"
            alt="edit"
            width="20px"
            height="20px"
          />
          <img
            *ngIf="editMode"
            src="assets/images/virtusa-icons/tick-light.svg"
            alt="save"
            width="15px"
            height="15px"
          />
        </span>
      </div>

      <div class="multi-column">
        <div class="summary-row" *ngIf="isTestCase">
          <img
            src="assets/images/virtusa-icons/card-expand-icon-blue.svg" class="expand-img-blue"
            alt="expand" (click)="openStory()" (keydown.enter)="openStory()"
          />
          <span
            class="story-link"
            (click)="openStory()"
            (keydown.enter)="openStory()"
          >
            {{ selectedRow.key }}
          </span>

          <span class="separator">/</span>

          <span class="separator">
            {{ selectedRow.testCaseId }}
          </span>

          <span class="priority-chip" [ngClass]="getPriorityClass(selectedRow.priority)" *ngIf="selectedRow.priority">
            {{ getPriorityLabel(selectedRow.priority) }}
          </span>
        </div>

        <div class="testcase-title" *ngIf="isTestCase">
          {{ selectedRow.testCase }}
        </div>

        <div class="column-item" *ngFor="let item of configs.moreDetails">
          <span class="header-12">{{ item?.display_name }}</span>
          @if(item?.key === 'qualityReportId' && selectedRow[item?.key]) {
            <ng-container>
              <div class="d-flex flex-row align-items-center justify-content-flex-start"><span>
                {{selectedRow[item?.key]}}
              </span>
              <img
                src="assets/images/virtusa-icons/card-expand-icon.svg" class="expand-img"
                alt="download" (click)="openReport()" (keydown.enter)="openReport()"
              /></div>
            </ng-container>
          }  @else if(item?.key === 'traceability' && selectedRow[item?.key]) {
            <ng-container>
              <div class="d-flex flex-row align-items-center justify-content-flex-start trace-div">
                <img
                  src="assets/images/virtusa-icons/card-expand-icon-blue.svg" class="expand-img-blue"
                  alt="download" (click)="openTraceability()" (keydown.enter)="openTraceability()"
                />
                <!-- <span class="story-link" (click)="openTraceability()" (keydown.enter)="openTraceability()">
                  {{selectedRow[item?.key]}}
                </span> -->
                <span  class="story-link"
                (click)="openTraceability()"
                (keydown.enter)="openTraceability()">
                {{ getCoveredCount(selectedRow[item?.key], selectedRow.key) }}
                Business Rule Covered
              </span>
             </div>
            </ng-container>
          }
          @else if(item?.key != 'feedback') {
          <!-- Editable Input -->
          <ng-container *ngIf="editMode">
            <!-- <input
              *ngIf="isString(selectedRow[item?.key])"
              [(ngModel)]="selectedRow[item?.key]"
              class="header-12-1"
            /> -->

            <textarea
              [(ngModel)]="selectedRow[item?.key]"
              rows="3"
              class="header-12-1"
            ></textarea>
          </ng-container>

          <!-- Read-only -->
          <ng-container *ngIf="!editMode">
            <ul
              *ngIf="isString(selectedRow[item?.key]) && !item._viewType && hasBulletMarkers(selectedRow[item?.key])"
              class="header-13-1 tct-bullet-list"
              [ngClass]="{ title: item._config?.isBold }"
            >
              <li *ngFor="let point of parseBulletPoints(selectedRow[item?.key])">{{ point }}</li>
            </ul>
            <p
              *ngIf="isString(selectedRow[item?.key]) && !item._viewType && !hasBulletMarkers(selectedRow[item?.key])"
              class="header-13-1 preserve-whitespace"
              [ngClass]="{ title: item._config?.isBold }"
            >
              {{ selectedRow[item?.key] }}
            </p>
            <ol *ngIf="isArray(selectedRow[item?.key]) && !item._viewType"><li *ngFor="let point of selectedRow[item?.key]"><span class="header-12-1">{{ point }}</span></li></ol>

            <div *ngIf="item._viewType">

              <div *ngIf="item._viewType === 'rank'" class="m-rank">
                <app-star-ranker [rank]="selectedRow[item?.key]" [isError]="selectedRow[item?.key] <= 2"></app-star-ranker>
              </div>

            </div>
          </ng-container>
        }@else{
          <ng-container *ngIf="!editMode">
            <div class="d-flex flex-row">
              <mat-icon class="feedback-icon"
                *ngFor="let icon of item._config.value; let i = index"
                (click)="onThumbClick(i)"
                (keydown.enter)="onThumbClick(i)"
                [ngClass]="{
                  'clickable-item': item._config?.isClickable,
                  'activeUp': selectedRow?.isThumbUp === true && icon === 'thumb_up',
                  'activeDown': selectedRow?.isThumbUp === false && icon === 'thumb_down'
                }"
              >
                {{ icon }}
              </mat-icon>
            </div>
            <textarea
              *ngIf="selectedRow?.isThumbUp === false"
              class="form-control"
              [(ngModel)]="selectedRow.feedback"
              (blur)="onFeedbackSave()"
            >
            </textarea>
          </ng-container>
          }
        </div>

        <!-- <div *ngIf="configs?.isFeedback" class="column-item">
          <span class="header-12">Feedback</span>
          <span
            ><mat-icon
              (click)="handleFeedback('up')"
              [ngClass]="[
                'feedback-icon',
                selectedFeedback === 'up' ? 'activeUp' : ''
              ]"
              >thumb_up</mat-icon
            >
            <mat-icon
              (click)="handleFeedback('down')"
              [ngClass]="[
                'feedback-icon',
                selectedFeedback === 'down' ? 'activeDown' : ''
              ]"
              >thumb_down</mat-icon
            ></span
          >
          <input
            *ngIf="selectedFeedback === 'down'"
            [(ngModel)]="selectedRow[item?.key]"
            class="header-12-1"
          />
        </div> -->
      </div>
    </div>
  </div>
</div>
